import { useState, useEffect } from 'react';

export default function HeroSection() {
  const [imgError, setImgError] = useState(false);

  return (
    <section id="hero" className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center bg-background-950 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-background-950 via-background-950/95 to-primary-950/60"></div>
      <div className="absolute inset-0 opacity-30" style={{
        backgroundImage: 'radial-gradient(circle at 20% 50%, oklch(0.52 0.22 22 / 0.15) 0%, transparent 50%), radial-gradient(circle at 80% 30%, oklch(0.72 0.17 85 / 0.10) 0%, transparent 50%)'
      }}></div>

      <div className="relative w-full max-w-[1400px] mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/15 border border-primary-500/25 mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
              <span className="text-xs md:text-sm font-medium text-accent-300 whitespace-nowrap">每日更新 · 高清流畅</span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-background-50 leading-tight mb-4">
              被窝影院
              <span className="block text-xl sm:text-2xl md:text-3xl lg:text-4xl font-medium text-accent-300 mt-2">
                最新电影免费看，高分电影在线
              </span>
            </h1>

            <p className="text-sm md:text-base text-foreground-300/80 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-5">
              被窝影院汇聚海量电影资源，无论是院线热片、经典老片还是高分佳作，这里都能找到。
              无需下载、无需注册，打开就能流畅在线观看，每天都有新片上线。从动作大片到文艺小品，
              从国产精品到海外巨制，满足每一位影迷的观影口味。本周热推悬疑烧脑特辑，多部高分
              反转神作已更新，陪你度过每一个放松的夜晚。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-lg bg-primary-500/20 flex items-center justify-center">
                  <i className="ri-movie-2-line text-accent-400 text-lg"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-background-50 font-heading">28,000+</div>
                  <div className="text-xs text-foreground-400">影视资源覆盖</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-lg bg-primary-500/20 flex items-center justify-center">
                  <i className="ri-user-smile-line text-accent-400 text-lg"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-background-50 font-heading">99.7%</div>
                  <div className="text-xs text-foreground-400">无广告纯净播放</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-lg bg-primary-500/20 flex items-center justify-center">
                  <i className="ri-flashlight-line text-accent-400 text-lg"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-background-50 font-heading">每日更新</div>
                  <div className="text-xs text-foreground-400">新片不间断</div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a href="#cards" className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm transition-all duration-300 whitespace-nowrap flex items-center justify-center gap-2 cursor-pointer">
                <i className="ri-play-circle-line text-lg"></i>
                开始观影
              </a>
              <a href="#ranking" className="w-full sm:w-auto px-8 py-3.5 rounded-lg border border-background-300/30 hover:border-accent-400/50 text-background-200 hover:text-accent-300 font-medium text-sm transition-all duration-300 whitespace-nowrap flex items-center justify-center gap-2 cursor-pointer">
                <i className="ri-fire-line text-lg"></i>
                查看热榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            {!imgError ? (
              <div className="relative">
                <div className="absolute -inset-4 bg-gradient-to-r from-primary-500/20 via-accent-500/10 to-primary-500/20 rounded-2xl blur-2xl"></div>
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20collage%20with%20golden%20film%20reels%20and%20warm%20spotlights%20on%20dark%20theater%20background%20dramatic%20lighting%20rich%20red%20velvet%20curtains%20classic%20cinema%20aesthetic%20elegant%20composition%20deep%20shadows%20vintage%20movie%20texture&width=700&height=900&seq=hero-visual-01&orientation=portrait"
                  alt="被窝影院 - 沉浸式观影体验"
                  className="relative w-full h-auto rounded-xl object-cover"
                  onError={() => setImgError(true)}
                />
              </div>
            ) : (
              <div className="relative w-full aspect-[7/9] rounded-xl bg-background-800/50 flex items-center justify-center">
                <div className="text-center">
                  <i className="ri-movie-line text-5xl text-foreground-600"></i>
                  <p className="text-foreground-500 text-sm mt-2">被窝影院</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}